module.exports = __webpack_public_path__ + "static/media/蓝牙通信模块.babfbb2e.png";